import React from 'react'
import url from 'front-end-core/core/url'
import Grid from '@material-ui/core/Grid'
import { CURRENT_AWARENESS } from 'constants/controllers'
import { flatMappedStories } from 'pages/currentawareness/Util'
import { Story } from 'pages/dashboard/CaStories'
import { CaThemeProvider } from 'components/redesign/CaThemeProvider'
import ArrowLink from 'components/redesign/ArrowLink'
import Hidden from '@material-ui/core/Hidden'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import selectAolName from 'redux/selectors/selectAolName'
import { useSelector } from 'react-redux'

const RecentStoriesTitle = () => {
  const aol = useSelector(selectAolName)

  return (
    <>
      <Hidden mdUp>
        <div className='black pl8 mt7 mb6'>
          <span className='f3 b flt-l mr10'>Recent News</span>
          <ArrowLink text='View all news' url={url(CURRENT_AWARENESS, { aol })} textCx='mt4' />
        </div>
      </Hidden>
      <div className='relative'>
        <Hidden smDown>
          <div style={{ height: '4.5rem' }} className='absolute -top10 w-100 h5'>
            <div className='relative black pl6 h-100 w-100'>
              <div className='absolute bottom6 w-100'>
                <Grid container justify='space-between' className='flex-wrap-reverse'>
                  <Grid item className='f3 b mr6'>Recent News</Grid>
                  <Grid item className='pr6'>
                    <ArrowLink text='View all News' url={url(CURRENT_AWARENESS, { aol })} textCx='mt4' />
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>
        </Hidden>
      </div>
    </>
  )
}

const RecentStories = ({ homepageArticles, filterId }) => {
  const filteredStories = flatMappedStories(homepageArticles)
    .filter(story => story.id !== filterId)
    .sort((uno, dos) => uno.position - dos.position)
    .slice(0, 6)

  return (
    <CaThemeProvider>
      <RecentStoriesTitle />
      <div className='bt-thick bt--light-sea-green-2 mb6' />
      <Grid container direction='column'>
        <Grid container direction='row' spacing={2} className='mt0 pb4 ghost-grey h-100'>
          {filteredStories.map(story => (
            <Grid item xs={12} sm={6} md={12} key={story.id}>
              <Story {...story} />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </CaThemeProvider>
  )
}

const RecentStoriesWrapper = ({ homepageArticles, filterId }) => (
  <ResponseConsumer
    response={homepageArticles}
    content={() => <RecentStories {...{ homepageArticles, filterId }} />}
  />
)

export default RecentStoriesWrapper
